module.exports = __webpack_public_path__ + "img/loanStep1.244adb59.jpg";